module.exports = __webpack_public_path__ + "img/hidro2.f1d8da3b.jpg";